import baseService from './baseService'

export const userService = {
  login
}

function login (username, password, meta) {
  return baseService.postRequest('users/authenticate', { username: username, password: password, meta: meta })
}
